import { Button as SButton } from "@shadcn";
import { useTranslation } from "react-i18next";

export type BarBottomNavTemplateProps = {
  onReturnPressed: () => void;
  onContinuePressed: (() => void) | null;
  isContinueDisabled: boolean;
  altContinueText?: string | null;
};

export const BarBottomNavTemplate = ({
  onReturnPressed,
  onContinuePressed, // When set to null, the continue button is not shown
  isContinueDisabled,
  altContinueText = null
}: BarBottomNavTemplateProps): JSX.Element => {
  const { t } = useTranslation();
  const showContinue = typeof onContinuePressed === "function";
  const containerClassName = `flex items-center w-full bg-neutral-lightmax ${
    showContinue ? "justify-between" : "justify-start"
  } max-w-full mt-4 sticky bottom-0 pt-6 pb-8 border-t border-neutral-medium`;

  return (
    <div className="absolute bottom-0 w-full pr-12">
      <div className={containerClassName}>
        <SButton
          variant="outline"
          className="hover:bg-gray-100 w-28"
          onClick={onReturnPressed}
        >
          {t("common.goBack")}
        </SButton>
        {showContinue &&
          <SButton
            onClick={onContinuePressed!}
            disabled={isContinueDisabled}
            variant="default"
            className="disabled disabled:bg-gray-100 disabled:cursor-not-allowed w-56 hover:bg-primary-dark hover:opacity-80"
          >
            {altContinueText ? altContinueText : t("common.continue")}
          </SButton>
        }
      </div>
    </div>
  );
};
